"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSystemVariableResponse = exports.GetSystemVariableResponse = exports.GetSystemVariablesResponse = void 0;
class GetSystemVariablesResponse {
}
exports.GetSystemVariablesResponse = GetSystemVariablesResponse;
class GetSystemVariableResponse {
}
exports.GetSystemVariableResponse = GetSystemVariableResponse;
class UpdateSystemVariableResponse {
}
exports.UpdateSystemVariableResponse = UpdateSystemVariableResponse;
//# sourceMappingURL=system.js.map